import { useState, useEffect } from 'react';
import { api } from '../api';

const INTRO_LINE_1 = "\uD83E\uDDE9 nice. you clicked the thing 5 times.";
const INTRO_LINE_2 = "welcome to the guestbook. built by bschramm.";
const INTRO_LINE_3 = "this whole app started as \u201Cwe need better bid tracking\u201D and became\u2026 whatever this is. if you found this, say hi. i read these. probably at 2am when i should be sleeping.";

export default function GuestbookModal({ onClose }) {
  const [message, setMessage] = useState('');
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [signing, setSigning] = useState(false);
  const [justSigned, setJustSigned] = useState(false);

  useEffect(() => {
    api.getGuestbook().then(setEntries).catch(() => {}).finally(() => setLoading(false));
  }, []);

  async function handleSign() {
    if (!message.trim() || signing) return;
    setSigning(true);
    try {
      const entry = await api.signGuestbook(message.trim());
      setEntries(prev => [entry, ...prev]);
      setMessage('');
      setJustSigned(true);
      setTimeout(() => setJustSigned(false), 2500);
    } catch (err) {
      alert('Could not sign guestbook: ' + err.message);
    }
    setSigning(false);
  }

  function fmt(dateStr) {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) +
      ' at ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  }

  return (
    <div className="guestbook-overlay" onClick={onClose}>
      <div className="guestbook-modal" onClick={e => e.stopPropagation()}>
        <button className="guestbook-close" onClick={onClose} aria-label="Close">&times;</button>

        <div className="guestbook-intro">
          <div className="guestbook-intro-title">{INTRO_LINE_1}</div>
          <p>{INTRO_LINE_2}</p>
          <p>{INTRO_LINE_3}</p>
        </div>

        <div className="guestbook-sign">
          <label>leave a note</label>
          <textarea
            value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder="something about finding this, a roast, a joke, a hello — whatever"
            rows={3}
            maxLength={2000}
            autoFocus
          />
          <div className="guestbook-sign-actions">
            <span className="guestbook-char-count">{message.length}/2000</span>
            <button
              className="btn btn-primary"
              onClick={handleSign}
              disabled={signing || !message.trim()}
            >
              {signing ? 'signing\u2026' : justSigned ? '\u2713 signed' : 'sign the book'}
            </button>
          </div>
        </div>

        <div className="guestbook-entries">
          <div className="guestbook-entries-header">
            {loading ? 'loading\u2026' : `${entries.length} ${entries.length === 1 ? 'signature' : 'signatures'} before you`}
          </div>
          {!loading && entries.length === 0 && (
            <div className="guestbook-empty">nobody yet. be the first. \uD83D\uDC4B</div>
          )}
          {entries.map(e => (
            <div key={e.EntryId} className="guestbook-entry">
              <div className="guestbook-entry-header">
                <span className="guestbook-entry-name">{e.SignedBy}</span>
                <span className="guestbook-entry-date">{fmt(e.SignedAt)}</span>
              </div>
              <div className="guestbook-entry-message">{e.Message}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
